import "./App.css";
import { useEffect, useState } from "react";
import "./Modal.css";

function App() {
  const [users, setUsers] = useState(
    JSON.parse(localStorage.getItem("people") || "[]"),
  );

  return (
    <>
      <Table users={users} setUsers={setUsers} />
    </>
  );
}

function Table({ users, setUsers }) {
  const [editId, setEditId] = useState(null);
  const [editId2, setEdit2Id] = useState(null);
  const [editId3, setEdit3Id] = useState(null);
  const [showModalEdit, setShowModalEdit] = useState(false);

  const [userSelected, setUserSelected] = useState(null);

  // const oldData = JSON.parse(localStorage.getItem("people") || "[]");
  useEffect(() => {
    localStorage.setItem("people", JSON.stringify(users));
    console.log("users changed:", users);
  }, [users]);

  const deleteData = (id) => {
    const newUsers = users.filter((user) => user.id !== id);
    setUsers(newUsers);
    localStorage.setItem("people", JSON.stringify(newUsers));
  };

  const updateUser = (id, field, value) => {
    const newUsers = users.map((user) =>
      user.id === id ? { ...user, [field]: value } : user,
    );

    setUsers(newUsers);
    localStorage.setItem("people", JSON.stringify(newUsers));
  };

  return (
    <div className="p-8 m-8">
      <table className="w-full border-collapse bg-white text-left text-sm text-gray-500">
        <thead className="bg-gray-50">
          <tr>
            <th scope="col" className="px-6 py-4 font-medium text-gray-900">
              Name
            </th>
            <th scope="col" className="px-6 py-4 font-medium text-gray-900">
              Age
            </th>
            <th scope="col" className="px-6 py-4 font-medium text-gray-900">
              Nickname
            </th>
            <th scope="col" className="px-6 py-4 font-medium text-gray-900">
              Action
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 border-t border-gray-100">
          {users.length === 0 ? (
            <tr>
              <td colSpan="4" className="px-6 py-4 text-center text-gray-500">
                ไม่มีข้อมูล
              </td>
            </tr>
          ) : (
            users.map((user, index) => (
              <tr key={user.id}>
                <td
                  onDoubleClick={() => setEditId(user.id)}
                  className="px-6 py-4 font-medium text-gray-900"
                >
                  {editId === user.id ? (
                    <input
                      autoFocus
                      value={user.name}
                      onChange={(e) =>
                        updateUser(user.id, "name", e.target.value)
                      }
                      onBlur={() => setEditId(null)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.target.blur();
                        }
                      }}
                    />
                  ) : (
                    user.name
                  )}
                </td>

                <td
                  onDoubleClick={() => setEdit2Id(user.id)}
                  className="px-6 py-4 font-medium text-gray-900"
                >
                  {editId2 === user.id ? (
                    <input
                      autoFocus
                      value={user.age}
                      onChange={(e) =>
                        updateUser(user.id, "age", e.target.value)
                      }
                      onBlur={() => setEdit2Id(null)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.target.blur();
                        }
                      }}
                    />
                  ) : (
                    user.age
                  )}
                </td>

                <td
                  onDoubleClick={() => setEdit3Id(user.id)}
                  className="px-6 py-4 font-medium text-gray-900"
                >
                  {editId3 === user.id ? (
                    <input
                      autoFocus
                      value={user.nickName}
                      onChange={(e) =>
                        updateUser(user.id, "nickName", e.target.value)
                      }
                      onBlur={() => setEdit3Id(null)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.target.blur();
                        }
                      }}
                    />
                  ) : (
                    user.nickName
                  )}
                </td>

                <th className="px-6 py-4">
                  <div className="flex gap-2">
                    <button
                      type="button"
                      onClick={() => {
                        setUserSelected(user);
                        setShowModalEdit(true);
                      }}
                      className="inline-flex items-center gap-1.5 rounded-lg border border-green-500 bg-green-500 px-5 py-2.5 text-center text-sm font-medium text-white shadow-sm transition-all hover:border-green-700 hover:bg-green-700 focus:ring focus:ring-green-200 disabled:cursor-not-allowed disabled:border-green-300 disabled:bg-green-300"
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      onClick={() => deleteData(user.id)}
                      className="inline-flex items-center gap-1.5 rounded-lg border border-red-500 bg-red-500 px-5 py-2.5 text-center text-sm font-medium text-white shadow-sm transition-all hover:border-red-700 hover:bg-red-700 focus:ring focus:ring-red-200 disabled:cursor-not-allowed disabled:border-red-300 disabled:bg-red-300"
                    >
                      Delete
                    </button>
                  </div>
                </th>
              </tr>
            ))
          )}
        </tbody>
      </table>
      <div>
        {showModalEdit && (
          <>
            <Edit
              allUser={users}
              users={userSelected}
              setUsers={setUsers}
              showModal={showModalEdit}
              setShowModal={setShowModalEdit}
            />
          </>
        )}
      </div>
      <div className="pt-4">
        <Add users={users} setUsers={setUsers} />
      </div>
    </div>
  );
}

function Edit({allUser, users, setUsers, showModal, setShowModal }) {
  const [inputName, setInputName] = useState("");
  const [inputAge, setInputAge] = useState("");
  const [inputNickName, setInputNickName] = useState("");

  console.log("users : ", allUser);
  

  useEffect(() => {
  if (users) {
    setInputName(users.name || "");
    setInputAge(users.age || "");
    setInputNickName(users.nickName || "");
  }
}, [users]);

  return (
    <>
      {/* MOdal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal ">
            <button
              type="button"
              className="close-button"
              onClick={() => {
                setShowModal(false);
              }}
            >
              &times;
            </button>

            <div className="flex flex-col gap-2">
              <label
                for="name"
                className=" text-xs mb-1 block font-medium text-gray-700"
              >
                Name
              </label>
              <input
                type="text"
                value={inputName}
                onChange={(e) => setInputName(e.target.value)}
                className="text-xs block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-400 focus:ring focus:ring-primary-200 focus:ring-opacity-50 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500"
                placeholder="Name"
              />

              <label
                for="age"
                className="mb-1 block text-xs font-medium text-gray-700"
              >
                Age
              </label>
              <input
                type="text"
                value={inputAge}
                onChange={(e) => setInputAge(e.target.value)}
                className="text-xs block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-400 focus:ring focus:ring-primary-200 focus:ring-opacity-50 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500"
                placeholder="Age"
              />

              <label
                for="nickName"
                className="mb-1 block text-xs font-medium text-gray-700"
              >
                NickName
              </label>
              <input
                type="text"
                value={inputNickName}
                onChange={(e) => setInputNickName(e.target.value)}
                className="text-xs block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-400 focus:ring focus:ring-primary-200 focus:ring-opacity-50 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500"
                placeholder="NickName"
              />
            </div>
            <div className="mt-4">
              <button
                type="button"
                onClick={() => {
                  // const dataForm = {
                  //   id: users.id,
                  //   name: inputName || "-",
                  //   age: inputAge || "-",
                  //   nickName: inputNickName || "-",
                  // };

                  const updateUser = allUser.map((data)=>
                    data.id === users.id ? {
                      ...data,
                      name : inputName || "-",
                      age : inputAge || "-",
                      nickName : inputNickName || "-"
                    } : data
                  );

                  setUsers(updateUser);
                  localStorage.setItem("people", JSON.stringify(updateUser));

                  setInputName("");
                  setInputAge("");
                  setInputNickName("");

                  setShowModal(false);
                }}
                className="rounded-lg border border-primary-500 bg-primary-500 px-5 py-2.5 text-center text-sm font-medium text-white shadow-sm transition-all hover:border-primary-700 hover:bg-primary-700 focus:ring focus:ring-primary-200 disabled:cursor-not-allowed disabled:border-primary-300 disabled:bg-primary-300"
              >
                Edit
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function Add({ users, setUsers }) {
  const [showModal, setShowModal] = useState(false);

  const [inputName, setInputName] = useState("");
  const [inputAge, setInputAge] = useState("");
  const [inputNickName, setInputNickName] = useState("");

  useEffect(() => {
    console.log("showModal :", showModal);
  }, [showModal]);

  useEffect(() => {
    console.log("Name :", inputName);
    console.log("Age :", inputAge);
    console.log("Nickname :", inputNickName);
  }, [inputName, inputAge, inputNickName]);

  return (
    <div>
      <button
        type="button"
        onClick={() => {
          setShowModal(!showModal);
        }}
        className="rounded-lg border border-primary-500 bg-primary-500 px-5 py-2.5 text-center text-sm font-medium text-white shadow-sm transition-all hover:border-primary-700 hover:bg-primary-700 focus:ring focus:ring-primary-200 disabled:cursor-not-allowed disabled:border-primary-300 disabled:bg-primary-300"
      >
        Add
      </button>

      {/* MOdal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal ">
            <button
              type="button"
              className="close-button"
              onClick={() => {
                setShowModal(false);
              }}
            >
              &times;
            </button>

            <div className="flex flex-col gap-2">
              <label
                for="name"
                className=" text-xs mb-1 block font-medium text-gray-700"
              >
                Name
              </label>
              <input
                type="text"
                value={inputName}
                onChange={(e) => setInputName(e.target.value)}
                className="text-xs block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-400 focus:ring focus:ring-primary-200 focus:ring-opacity-50 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500"
                placeholder="Name"
              />

              <label
                for="age"
                className="mb-1 block text-xs font-medium text-gray-700"
              >
                Age
              </label>
              <input
                type="text"
                value={inputAge}
                onChange={(e) => setInputAge(e.target.value)}
                className="text-xs block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-400 focus:ring focus:ring-primary-200 focus:ring-opacity-50 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500"
                placeholder="Age"
              />

              <label
                for="nickName"
                className="mb-1 block text-xs font-medium text-gray-700"
              >
                NickName
              </label>
              <input
                type="text"
                value={inputNickName}
                onChange={(e) => setInputNickName(e.target.value)}
                className="text-xs block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-400 focus:ring focus:ring-primary-200 focus:ring-opacity-50 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500"
                placeholder="NickName"
              />
            </div>
            <div className="mt-4">
              <button
                type="button"
                onClick={() => {
                  const dataForm = {
                    id: crypto.randomUUID(),
                    name: inputName || "-",
                    age: inputAge || "-",
                    nickName: inputNickName || "-",
                  };

                  const newUsers = [...users, dataForm];
                  setUsers(newUsers);

                  localStorage.setItem("people", JSON.stringify(newUsers));

                  setInputName("");
                  setInputAge("");
                  setInputNickName("");

                  setShowModal(false);
                }}
                className="rounded-lg border border-primary-500 bg-primary-500 px-5 py-2.5 text-center text-sm font-medium text-white shadow-sm transition-all hover:border-primary-700 hover:bg-primary-700 focus:ring focus:ring-primary-200 disabled:cursor-not-allowed disabled:border-primary-300 disabled:bg-primary-300"
              >
                Add
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
